export default "__VITE_ASSET__BitHQqWm__"